import { ChangeDetectionStrategy, Component } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { map } from 'rxjs/operators'


@Component({
  selector: 'adex-email-confirmation-container',
  templateUrl: './email-confirmation-container.component.html',
  styleUrls: [ './email-confirmation-container.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailConfirmationContainerComponent {

  public email$ = this.router.queryParamMap.pipe(
    map(params => params.get('email'))
  )

  constructor(private readonly router: ActivatedRoute) {
  }

}
